import {Box, IconButton, Menu, MenuItem} from "@mui/material";
import React, {useRef, useState} from "react";
import {HelpOutline} from "@mui/icons-material";
import {selectHelpAvailable} from "../../../redux/selectors/editor";
import {connect} from "react-redux";

interface IHelpMenu {
    helpAvailable: boolean
    onShowDialog: (dialog: string) => void
    title: string
}
function HelpMenu({helpAvailable, onShowDialog, title}: IHelpMenu) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const handleItemClick = (dialog: string) => () => {
        setOpen(false);
        onShowDialog(dialog);
    };

    return (
        <Box>
            <IconButton color="inherit" data-mode="help" title={title}
                        onClick={() => setOpen(true)} ref={anchorRef}>
                <HelpOutline />
            </IconButton>
            <Menu anchorEl={anchorRef.current} open={open} onClose={() => setOpen(false)}>
                <MenuItem disabled={! helpAvailable} onClick={handleItemClick("help")}>
                    {title}
                </MenuItem>
                <MenuItem onClick={handleItemClick("changelog")}>
                    Changelog
                </MenuItem>
                <MenuItem onClick={handleItemClick("about")}>
                    About Pathway
                </MenuItem>
            </Menu>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    helpAvailable: selectHelpAvailable(store)
});
export default connect(mapStateToProps, {
})(HelpMenu);